(function () {
    var bookHeader = {
        $infocusCoverImg: '',
        $othersCoverImg: '',
        $bookSeriesCode: '',
        $downloadBtn: '',
        $infocusCoverImgSrc: '',
        $othersCoverImgSrc: '',
        $imgPath: null,
        $getAccessBtn: '',
        $cancelBtn: '',
        $moreAccessOptionsLink: '',
        $infocusBookPage: '',
        $infocusBookTitle: '',

        init: function () {
            bookHeader.$infocusCoverImg = $('.book-toc-infocus-header_cover img');
            bookHeader.$othersCoverImg = $('.book-toc-header_cover img');

            bookHeader.$bookSeriesCode = $("input[name='book_seriesCode']").val();

            bookHeader.$downloadBtn = $('.download-btn-container button');

            bookHeader.$infocusCoverImgSrc = bookHeader.$infocusCoverImg.attr('datasrc');
            bookHeader.$othersCoverImgSrc = bookHeader.$othersCoverImg.attr('src');

            bookHeader.$getAccessBtn = $('.get-access-btn');
            bookHeader.$cancelBtn = $('.preview__options .btn-cancel');
            bookHeader.$moreAccessOptionsLink = $('.more-access-btn');
            bookHeader.$infocusBookPage = $('.infocus');
            bookHeader.$infocusBookTitle = $('h1 .hlFld-Title').text();
            bookHeader.$googlePlayBtn = document.querySelector('.google-play__link');

            bookHeader.controller();
            bookHeader.addEventListeners();
        },
        controller: function () {
            var cover;
            var coverCheck;
            //hide Download cover button for 'styleguide' and 'advance' books, and if the cover image does not exists
            bookHeader.hideDownloadButton(bookHeader.getBookSeriesCode());
            bookHeader.$downloadBtn.click(function (event) {
                ajaxOverlay('body');

                // create the cover path
                cover = bookHeader.$imgPath;
                // check for the cover's existence and only show the high-res button if it exists
                if (window.XMLHttpRequest) coverCheck = new XMLHttpRequest();
                else if (window.ActiveXObject) coverCheck = new ActiveXObject('Microsoft.XMLHTTP'); // for ie6

                coverCheck.open('GET', cover, true);
                coverCheck.send(null);

                coverCheck.onreadystatechange = function () {
                    if (coverCheck.readyState === 4) {
                        if (coverCheck.status === 200) {
                            removeAjaxOverlay('body');
                            setTimeout(function () {
                                parent.window.location = cover;
                            }, 100);
                        } else {
                            removeAjaxOverlay('body');
                            alert('Sorry, there is not a high-resolution version of this cover.');
                        }
                    }
                };
                return false;
            });

            if (bookHeader.$getAccessBtn.length > 0) {
                bookHeader.$getAccessBtn.click(function () {
                    bookHeader.$cancelBtn.click();
                    bookHeader.$moreAccessOptionsLink.click();
                });
            }
        },
        addEventListeners: function () {
            bookHeader.$googlePlayBtn?.addEventListener('click', bookHeader.googleAnalyticsInit);
        },
        //to get the book series code
        getBookSeriesCode: function () {
            return bookHeader.$bookSeriesCode;
        },

        hideDownloadButton: function (bookSeriesCode) {
            if (bookSeriesCode == null || !(bookSeriesCode.length > 0)) {
                bookHeader.$downloadBtn.hide();
                return;
            }

            // read the image path
            if (bookSeriesCode === 'infocus') bookHeader.$imgPath = bookHeader.$infocusCoverImgSrc;
            else bookHeader.$imgPath = bookHeader.$othersCoverImgSrc;

            if (bookHeader.$imgPath == null || !bookHeader.$imgPath.length > 0) {
                bookHeader.$downloadBtn.hide();
                return;
            }

            if (
                bookSeriesCode === 'acsguide' ||
                bookSeriesCode === 'styleguide' ||
                bookSeriesCode === 'advances' ||
                bookSeriesCode === 'infocus'
            ) {
                bookHeader.$downloadBtn.hide();
            }
        },

        googleAnalyticsInit: function () {
            if (bookHeader.$infocusBookPage.length) {
                let infocusTitle = bookHeader.$infocusBookTitle;
                window.gtag?.('event', 'Click', {
                    event_category: 'Google_Play_Infocus',
                    event_label: infocusTitle,
                });
            }
        },
    };
    UX.bookHeader = bookHeader; // add to global namespace
})();
